import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

enum OfferBoxGTMEventType {
    INVEST_TILE = "invest_tile",
    INVEST_TILE_SELECT = "invest_tile_select"
}

const investTileSwipe = (offerId: number, tileIndex: number, swipesNumber: number) => {
    hitGoogleTagManager({
        event: OfferBoxGTMEventType.INVEST_TILE,
        invest_id: `${offerId}`,
        invest_number: tileIndex + 1, // index of the investment in the list (starting from 1)
        swipes_number: swipesNumber // number of swipes e.g. "3" - 2 swipes to the right and 1 swipe to the left
    });
};

const investTileSelect = (offerId: number, tileIndex: number, swipesNumber: number | null, slideIndex: number | null) => {
    hitGoogleTagManager({
        event: OfferBoxGTMEventType.INVEST_TILE_SELECT,
        invest_id: `${offerId}`,
        invest_number: tileIndex + 1, // index of the investment in the list (starting from 1)
        swipes_number: swipesNumber || "nie_dotyczy", // number of swipes e.g. "3" - 2 swipes to the right and 1 swipe to the left
        selected_tile: typeof slideIndex === "number" ? slideIndex + 1 : "nie_dotyczy" // index of slide (starting from 1) in the moment of selecting the investment
    });
};

const investTileView = (offerId: number, tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_tile_view",
        invest_id: `${offerId}`,
        invest_number: `${tileIndex + 1}` // index of the investment in the list (starting from 1)
    });
};

const investTileImageClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_tile_image",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investTileButtonClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_tile_button",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investTileLinkClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_tile_link",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investTileLogoClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_tile_logo",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investTileOfferModal = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_tile_offer_modal",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investAdditionalImageClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_additional_image",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investAdditionalButtonClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_additional_button",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investAdditionalLinkClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_additional_link",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investAdditionalLogoClick = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_additional_logo",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

const investAdditionalOfferModal = (tileIndex: number) => {
    hitGoogleTagManager({
        event: "invest_additional_offer_modal",
        event_action: "click",
        event_label: tileIndex + 1 // position on the list (starting from 1)
    });
};

export const offerBoxTracking = {
    gtm: {
        investTileSwipe,
        investTileSelect,
        investTileView,
        investTileImageClick,
        investTileButtonClick,
        investTileLinkClick,
        investTileLogoClick,
        investTileOfferModal,
        investAdditionalImageClick,
        investAdditionalButtonClick,
        investAdditionalLinkClick,
        investAdditionalLogoClick,
        investAdditionalOfferModal
    }
};
